import type { PropDoc } from '@/runtime/shared/elements-definition';
import type { AccordionProps, AccordionItemProps } from './index';

type AccordionPropKeys = keyof AccordionProps;
type AccordionItemPropKeys = keyof AccordionItemProps;

/**
 * API docs mapping for `<e-accordion>` props.
 *
 * Keys come from {@link AccordionProps}, values are used by the docs renderer
 * to build the props table.
 */
export const accordionPropsDocs: Record<AccordionPropKeys, PropDoc> = {
  openItems: {
    name: 'open-items',
    type: 'string[]',
    descriptionKey: 'accordion.e-accordion.open-items.description'
  },
  multiple: {
    name: 'multiple',
    type: 'boolean',
    defaultValue: 'false',
    descriptionKey: 'accordion.e-accordion.multiple.description'
  }
} as const;

/**
 * API docs mapping for `<e-accordion-item>` props.
 *
 * Keys come from {@link AccordionItemProps}, values are used by the docs
 * renderer to build the props table.
 */
export const accordionItemPropsDocs: Record<AccordionItemPropKeys, PropDoc> = {
  value: {
    name: 'value',
    type: 'string',
    required: true,
    descriptionKey: 'accordion.e-accordion-item.value.description'
  },
  open: {
    name: 'open',
    type: 'boolean',
    defaultValue: 'false',
    descriptionKey: 'accordion.e-accordion-item.open.description'
  },
  disabled: {
    name: 'disabled',
    type: 'boolean',
    descriptionKey: 'accordion.e-accordion-item.disabled.description'
  },
  size: {
    name: 'size',
    type: `'xs' | 'sm' | 'md' | 'lg' | 'xl'`,
    descriptionKey: 'accordion.e-accordion-item.size.description'
  },
  color: {
    name: 'color',
    type: 'string',
    descriptionKey: 'accordion.e-accordion-item.color.description'
  },
  variant: {
    name: 'variant',
    type: 'string',
    descriptionKey: 'accordion.e-accordion-item.variant.description'
  }
} as const;
